var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Observable } from "rxjs";
import { switchMap, map, withLatestFrom, tap, mergeMap } from "rxjs/operators";
import { CustomersApi, OrganisationsApi } from "@careapp/angular-sdk";
import { Actions, Effect } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { GoogleGeocodeService } from "../../shared/services/index";
import { Customers } from "../actions/index";
import * as selectors from "../reducers/index";
import { FAMILY_ROLE, CUSTOMER_FAMILY_ROLE } from "@careapp/core";
var of = Observable.of;
var CustomersEffects = /** @class */ (function () {
    function CustomersEffects(store, actions$, api, customerApi, locationService) {
        var _this = this;
        this.store = store;
        this.actions$ = actions$;
        this.api = api;
        this.customerApi = customerApi;
        this.locationService = locationService;
        this.paginate = this.actions$
            .ofType(Customers.PAGE_CHANGE)
            .pipe(map(function (action) { return Customers.RequestAllAction; }));
        this.updateFilter = this.actions$
            .ofType(Customers.UPDATE_FILTER)
            .pipe(map(function (action) { return Customers.RequestPageAction(); }));
        this.updatePagination = this.actions$
            .ofType(Customers.RESET_PAGE, Customers.REQUEST_PAGE)
            .pipe(tap(function (action) {
            _this.store.dispatch(Customers.RequestCountAction());
            _this.store.dispatch(Customers.RequestAllAction);
        }));
        this.findById = this.actions$.ofType(Customers.REQUEST_BY_ID).pipe(mergeMap(function (action) {
            return _this.customerApi
                .findById(action.payload.id)
                .map(function (result) { return Customers.ResponseSuccessByIdAction(result); })
                .catch(function (err) { return of(Customers.ResponseFailByIdAction(err)); });
        }));
        this.countCustomers = this.actions$.ofType(Customers.REQUEST_COUNT).pipe(withLatestFrom(this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS)), this.store.select(selectors.getFilter(selectors.CUSTOMERS))), switchMap(function (_a) {
            var action = _a[0], organisationId = _a[1], filter = _a[2];
            return _this.api
                .countCustomers(organisationId, filter)
                .map(function (payload) {
                return Customers.ResponseSuccessCountAction(payload.count);
            })
                .catch(function (err) { return of(Customers.ResponseFailCountAction(err)); });
        }));
        this.getCustomers = this.actions$.ofType(Customers.REQUEST_ALL).pipe(withLatestFrom(this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS)), this.store.select(selectors.getPageination(selectors.CUSTOMERS)), this.store.select(selectors.getFilter(selectors.CUSTOMERS))), switchMap(function (_a) {
            var action = _a[0], organisationId = _a[1], pagination = _a[2], filter = _a[3];
            return _this.api
                .listCustomers(organisationId, __assign({}, filter, { limit: pagination.pageSize, skip: pagination.pageSize * pagination.pageIndex }))
                .map(function (payload) {
                return Customers.ResponseSuccessAllAction(payload);
            })
                .catch(function (err) { return of(Customers.ResponseFailAllAction(err)); });
        }));
        this.createCustomer = this.actions$.ofType(Customers.REQUEST_CREATE).pipe(withLatestFrom(this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS))), switchMap(function (_a) {
            var action = _a[0], organisationId = _a[1];
            var details = __assign({}, action.payload);
            if (!details.location ||
                details.location.lat === "" ||
                details.location.lng === "") {
                details.location = null;
            }
            return _this.api
                .createCustomer(organisationId, details)
                .map(function (payload) {
                return Customers.ResponseSuccessCreateAction(payload);
            })
                .catch(function (err) { return of(Customers.ResponseFailCreateAction(err)); });
        }));
        this.bulkAddCustomersAndInviteFamilies = this.actions$
            .ofType(Customers.REQUEST_BULK_ADD_CUSTOMERS)
            .pipe(map(function (action) {
            return action.payload.map(function (customerRow) { return ({
                customerPayload: {
                    firstName: customerRow.firstName,
                    lastName: customerRow.lastName,
                    dateOfBirth: customerRow.dateOfBirth.length > 0
                        ? customerRow.dateOfBirth
                        : null,
                    address: {
                        address1: customerRow.address1,
                        address2: customerRow.address2,
                        town: customerRow.town,
                        state: customerRow.state,
                        postcode: customerRow.postcode,
                        country: customerRow.country
                    }
                },
                familyInvites: [
                    customerRow.family_Email,
                    customerRow.family_Email1,
                    customerRow.family_Email2,
                    customerRow.family_Email3,
                    customerRow.family_Email4,
                    customerRow.family_Email5,
                    customerRow.family_Email6,
                    customerRow.family_Email7,
                    customerRow.family_Email8,
                    customerRow.family_Email9,
                    customerRow.family_Email10
                ]
            }); });
        }), withLatestFrom(this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS))), switchMap(function (_a) {
            var payload = _a[0], organisationId = _a[1];
            return __awaiter(_this, void 0, void 0, function () {
                var results, i, customerRow, customerResult, filtered, inviteResults, _i, filtered_1, invite, inviteResult, err_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            results = [];
                            i = 0;
                            _b.label = 1;
                        case 1:
                            if (!(i < payload.length)) return [3 /*break*/, 11];
                            customerRow = payload[i];
                            _b.label = 2;
                        case 2:
                            _b.trys.push([2, 8, 9, 10]);
                            return [4 /*yield*/, this.api
                                    .createCustomer(organisationId, customerRow.customerPayload)
                                    .toPromise()];
                        case 3:
                            customerResult = _b.sent();
                            filtered = customerRow.familyInvites.filter(function (invite) { return invite != null && invite.length > 0; });
                            inviteResults = [];
                            _i = 0, filtered_1 = filtered;
                            _b.label = 4;
                        case 4:
                            if (!(_i < filtered_1.length)) return [3 /*break*/, 7];
                            invite = filtered_1[_i];
                            return [4 /*yield*/, this.api
                                    .invite(organisationId, {
                                    email: invite,
                                    role: FAMILY_ROLE,
                                    permissions: [
                                        {
                                            modelId: customerResult.id,
                                            modelName: "Customer",
                                            role: CUSTOMER_FAMILY_ROLE
                                        }
                                    ]
                                })
                                    .toPromise()];
                        case 5:
                            inviteResult = _b.sent();
                            inviteResults.push(inviteResult);
                            _b.label = 6;
                        case 6:
                            _i++;
                            return [3 /*break*/, 4];
                        case 7:
                            results.push({
                                payload: customerRow,
                                response: customerResult,
                                invites: inviteResults,
                                hasError: false
                            });
                            return [3 /*break*/, 10];
                        case 8:
                            err_1 = _b.sent();
                            results.push({
                                payload: customerRow,
                                errors: err_1,
                                hasError: true
                            });
                            return [3 /*break*/, 10];
                        case 9:
                            this.store.dispatch(Customers.ProgressBulkAddCustomers((i + 1) / payload.length));
                            return [7 /*endfinally*/];
                        case 10:
                            i++;
                            return [3 /*break*/, 1];
                        case 11: return [2 /*return*/, Customers.ResponseSuccessBulkAddCustomers(results)];
                    }
                });
            });
        }));
        this.saveCustomer = this.actions$.ofType(Customers.REQUEST_SAVE).pipe(withLatestFrom(this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS))), switchMap(function (_a) {
            var action = _a[0], organisationId = _a[1];
            var details = __assign({}, action.payload.data);
            if (!details.location ||
                details.location.lat === "" ||
                details.location.lng === "") {
                details.location = null;
            }
            return _this.customerApi
                .updateById(action.payload.id, details)
                .map(function (payload) {
                return Customers.ResponseSuccessSaveAction(payload);
            })
                .catch(function (err) { return of(Customers.ResponseFailSaveAction(err)); });
        }));
    }
    /**
     * Attempts to add a location to each customer using the location service.
     * If fails, just continues without the location.
     *
     * @param customers The array of customers for the bulk import
     */
    CustomersEffects.prototype.addAddresses = function (customers) {
        return __awaiter(this, void 0, void 0, function () {
            var toReturn, BATCH_SIZE, pointer, slice;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        toReturn = [];
                        BATCH_SIZE = 5;
                        pointer = 0;
                        _a.label = 1;
                    case 1:
                        if (!(pointer <= customers.length)) return [3 /*break*/, 3];
                        slice = customers.slice(pointer, pointer + BATCH_SIZE);
                        return [4 /*yield*/, Promise.all(slice.map(function (customer) { return __awaiter(_this, void 0, void 0, function () {
                                var location, error_1;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            _a.trys.push([0, 2, , 3]);
                                            return [4 /*yield*/, this.locationService
                                                    .requestLocation(customer.address)
                                                    .toPromise()];
                                        case 1:
                                            location = _a.sent();
                                            return [3 /*break*/, 3];
                                        case 2:
                                            error_1 = _a.sent();
                                            location = { error: error_1 };
                                            return [3 /*break*/, 3];
                                        case 3:
                                            if (!location.error) {
                                                return [2 /*return*/, toReturn.push(__assign({}, customer, { location: location }))];
                                            }
                                            else {
                                                return [2 /*return*/, toReturn.push(customer)];
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 2:
                        _a.sent();
                        pointer += BATCH_SIZE;
                        return [3 /*break*/, 1];
                    case 3: return [2 /*return*/, toReturn];
                }
            });
        });
    };
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], CustomersEffects.prototype, "paginate", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], CustomersEffects.prototype, "updateFilter", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], CustomersEffects.prototype, "updatePagination", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], CustomersEffects.prototype, "findById", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], CustomersEffects.prototype, "countCustomers", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], CustomersEffects.prototype, "getCustomers", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], CustomersEffects.prototype, "createCustomer", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], CustomersEffects.prototype, "bulkAddCustomersAndInviteFamilies", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], CustomersEffects.prototype, "saveCustomer", void 0);
    return CustomersEffects;
}());
export { CustomersEffects };
